import React from 'react';
import moment from 'moment';

import TextField from 'modules/views/shared/TextField';
import DatePicker from 'modules/views/shared/DatePicker';
import Select from 'modules/views/shared/Select';
import MobileInput from 'modules/views/shared/MobileInput';
import Checkbox from 'modules/views/shared/Checkbox';

interface IFieldWrapper {
  field: any;
  value: string;
  error?: string;
  onChange: (value: string | boolean, meta?: any) => void;
  disabled?: boolean;
}

export const FieldWrapper = ({ field, value, error, onChange, disabled }: IFieldWrapper) => {
  switch (field?.dataType) {
    case 2: {
      const options = (field?.options || [])?.map(({ id, name }) => ({ value: id, label: name }));
      const selectedValue = options?.find(option => option.value === value) || null;
      return (
        <Select
          inputLabel={field.name}
          disabled={disabled}
          options={options}
          selectedValue={selectedValue}
          required={field?.projectField?.isMandatory}
          error={error}
          testId={`consent-field-${field.id}-input`}
          onChange={option => {
            onChange(option?.value);
          }}
        />
      );
    }
    case 3:
      return (
        <MobileInput
          disabled={disabled}
          label={field.name}
          testId={`consent-field-${field.id}-input`}
          required={field?.projectField?.isMandatory}
          placeholder={field.name}
          onChange={value => {
            onChange(value.phone, value);
          }}
          error={error}
          value={value}
        />
      );
    case 4:
      return (
        <DatePicker
          disabled={disabled}
          inputLabel={field.name}
          value={value}
          minDate={moment('01/01/1900')}
          maxDate={moment()}
          defaultCalendarMonth={moment()}
          required={field?.projectField?.isMandatory}
          testId={`consent-field-${field.id}-input`}
          onChange={date => {
            const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
            onChange(formattedDate);
          }}
          error={error}
        />
      );
    case 5:
      return (
        <Checkbox
          disabled={disabled}
          label={field.name}
          color="primary"
          testId={`consent-field-${field.id}-input`}
          onChange={e => onChange(e.target.checked)}
          checked={!!value}
          error={error}
        />
      );
    default:
      return (
        <TextField
          disabled={disabled}
          label={field.name}
          testId={`consent-field-${field.id}-input`}
          required={field?.projectField?.isMandatory}
          onChange={e => {
            onChange(e.target.value);
          }}
          value={value}
          error={error}
        />
      );
  }
};
